import { remove }        from 'lodash';
import PureGameElement   from '../../tools/PureGameElement';
import tileWater         from '../../../assets/img/tileWater.png';
import tearWater         from '../../../assets/img/tearWater.png';
import {
    gameWindowSize,
    diffBaseTearVelocity,
    tearWidth,
    tearFrequency, tearDelay
}                        from '../../constants/appConstants';
import { ambianceAudio } from '../../constants/audioConstants';
import { getRandomInt }  from '../../tools/functions';

class BackgroundManager extends PureGameElement {
    constructor ( scene ) {
        super( scene );
        this.tears = [];
        this._waterSprite = null;
        this._tearEvent = null;
    }

    get tearWidth () {
        return tearWidth;
    }

    get tearHeight () {
        return this.tearWidth;
    }

    get tearVelocity () {
        return this.scene.difficulty * diffBaseTearVelocity;
    }

    get tearX () {
        return Math.round( gameWindowSize.width / 6 * getRandomInt( 0, 5 ) );
    }

    preload () {
        super.preload();
        this.scene.load.audio( ambianceAudio.key, ambianceAudio.source );
        this.scene.load.image( 'tileWater', tileWater );
        this.scene.load.image( 'tearWater', tearWater );
    }

    create () {
        super.create();
        this.scene.sound.add( ambianceAudio.key, ambianceAudio.data );
        this.scene.sound.play( ambianceAudio.key );

        this._waterSprite = this.scene.add.tileSprite(
            0, 0,
            2000, 2000,
            'tileWater'
        );

        this._tearEvent = this.scene.time.addEvent( {
            delay: tearDelay,
            callback: this.spawnTear,
            callbackScope: this,
            loop: true
        } );
    }

    update () {
        super.update();
        this.tears.forEach( tear => {
            if ( tear.y > gameWindowSize.height + this.tearHeight ) {
                this.destroyTear( tear );
            }
        } );
    }

    spawnTear () {
        if ( getRandomInt( 0, tearFrequency ) !== 0 )
            return null;

        const newTear = this.scene.add.sprite( this.tearX, 0, 'tearWater' );

        this.scene.physics.world.enable( newTear );
        newTear.setSize( this.tearWidth, this.tearHeight );
        newTear.setDisplaySize( this.tearWidth, this.tearHeight );
        newTear.setOrigin( 0, 0 );
        newTear.body.setVelocity( 0, this.tearVelocity );

        this.tears.push( newTear );
    }

    destroyTear ( tear ) {
        remove( this.tears, a => a === tear );
    }
}

export default BackgroundManager;
